import {create} from "zustand";

export interface UserProfile {
    email?: string;
    name?: string;
    chats?: any[]
}

// Monthly usage as returned by the backend (POST /auth/user → plan.usage, POST /chat/sendMessage → usage)
export interface PlanUsage {
    period: string;
    messagesSent: number;
    voiceMessageSent: number;
}

export interface ProfileStore {
    user: UserProfile | null;
    // When the profile was last loaded from the server (ms), so pages can skip reloading a fresh one
    loadedAt: number;
    updateUser: (data: UserProfile) => void;
    updateUsage: (usage: PlanUsage) => void;
    updateChatPreview: (botId: string, lastMessage: any) => void;
    clearUser: () => void;
}

export const useProfileStore = create<ProfileStore>((set) => ({
    user: null,
    loadedAt: 0,
    updateUser: (data) =>
        set(() => ({
            user: data, // просто заменяем на то, что вернул backend
            loadedAt: Date.now(),
        })),
    // Keeps the usage meters current after each message without reloading the whole profile
    updateUsage: (usage) =>
        set((state) => {
            const user: any = state.user;
            if (!user?.plan) return {};
            return {user: {...user, plan: {...user.plan, usage}}};
        }),
    // Last message shown in the chat list
    updateChatPreview: (botId, lastMessage) =>
        set((state) => {
            if (!state.user?.chats) return {};
            return {
                user: {
                    ...state.user,
                    chats: state.user.chats.map((el) => el.bot_id === botId ? {...el, last_message: lastMessage} : el),
                },
            };
        }),
    clearUser: () =>
        set(() => ({
            user: null,
            loadedAt: 0,
        })),
}));
